// source: contentstore/parts.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var google_protobuf_struct_pb = require('google-protobuf/google/protobuf/struct_pb.js');
goog.object.extend(proto, google_protobuf_struct_pb);
goog.exportSymbol('proto.contentstore.PartBody', null, global);
goog.exportSymbol('proto.contentstore.PartKind', null, global);
goog.exportSymbol('proto.contentstore.PartNode', null, global);
goog.exportSymbol('proto.contentstore.PartsManifest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.contentstore.PartsManifest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.contentstore.PartsManifest.repeatedFields_, null);
};
goog.inherits(proto.contentstore.PartsManifest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.contentstore.PartsManifest.displayName = 'proto.contentstore.PartsManifest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.contentstore.PartBody = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.contentstore.PartBody, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.contentstore.PartBody.displayName = 'proto.contentstore.PartBody';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.contentstore.PartNode = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.contentstore.PartNode, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.contentstore.PartNode.displayName = 'proto.contentstore.PartNode';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.contentstore.PartsManifest.repeatedFields_ = [4,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.contentstore.PartsManifest.prototype.toObject = function(opt_includeInstance) {
  return proto.contentstore.PartsManifest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.contentstore.PartsManifest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.contentstore.PartsManifest.toObject = function(includeInstance, msg) {
  var f, obj = {
    formatVersion: jspb.Message.getFieldWithDefault(msg, 1, 0),
    originalMime: jspb.Message.getFieldWithDefault(msg, 2, ""),
    rootNode: jspb.Message.getFieldWithDefault(msg, 3, 0),
    bodiesList: jspb.Message.toObjectList(msg.getBodiesList(),
    proto.contentstore.PartBody.toObject, includeInstance),
    nodesList: jspb.Message.toObjectList(msg.getNodesList(),
    proto.contentstore.PartNode.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.contentstore.PartsManifest}
 */
proto.contentstore.PartsManifest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.contentstore.PartsManifest;
  return proto.contentstore.PartsManifest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.contentstore.PartsManifest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.contentstore.PartsManifest}
 */
proto.contentstore.PartsManifest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setFormatVersion(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOriginalMime(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRootNode(value);
      break;
    case 4:
      var value = new proto.contentstore.PartBody;
      reader.readMessage(value,proto.contentstore.PartBody.deserializeBinaryFromReader);
      msg.addBodies(value);
      break;
    case 5:
      var value = new proto.contentstore.PartNode;
      reader.readMessage(value,proto.contentstore.PartNode.deserializeBinaryFromReader);
      msg.addNodes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.contentstore.PartsManifest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.contentstore.PartsManifest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.contentstore.PartsManifest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.contentstore.PartsManifest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFormatVersion();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getOriginalMime();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRootNode();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getBodiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.contentstore.PartBody.serializeBinaryToWriter
    );
  }
  f = message.getNodesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.contentstore.PartNode.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint32 format_version = 1;
 * @return {number}
 */
proto.contentstore.PartsManifest.prototype.getFormatVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.contentstore.PartsManifest} returns this
 */
proto.contentstore.PartsManifest.prototype.setFormatVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string original_mime = 2;
 * @return {string}
 */
proto.contentstore.PartsManifest.prototype.getOriginalMime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.contentstore.PartsManifest} returns this
 */
proto.contentstore.PartsManifest.prototype.setOriginalMime = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 root_node = 3;
 * @return {number}
 */
proto.contentstore.PartsManifest.prototype.getRootNode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.contentstore.PartsManifest} returns this
 */
proto.contentstore.PartsManifest.prototype.setRootNode = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated PartBody bodies = 4;
 * @return {!Array<!proto.contentstore.PartBody>}
 */
proto.contentstore.PartsManifest.prototype.getBodiesList = function() {
  return /** @type{!Array<!proto.contentstore.PartBody>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.contentstore.PartBody, 4));
};


/**
 * @param {!Array<!proto.contentstore.PartBody>} value
 * @return {!proto.contentstore.PartsManifest} returns this
*/
proto.contentstore.PartsManifest.prototype.setBodiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.contentstore.PartBody=} opt_value
 * @param {number=} opt_index
 * @return {!proto.contentstore.PartBody}
 */
proto.contentstore.PartsManifest.prototype.addBodies = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.contentstore.PartBody, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.contentstore.PartsManifest} returns this
 */
proto.contentstore.PartsManifest.prototype.clearBodiesList = function() {
  return this.setBodiesList([]);
};


/**
 * repeated PartNode nodes = 5;
 * @return {!Array<!proto.contentstore.PartNode>}
 */
proto.contentstore.PartsManifest.prototype.getNodesList = function() {
  return /** @type{!Array<!proto.contentstore.PartNode>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.contentstore.PartNode, 5));
};


/**
 * @param {!Array<!proto.contentstore.PartNode>} value
 * @return {!proto.contentstore.PartsManifest} returns this
*/
proto.contentstore.PartsManifest.prototype.setNodesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.contentstore.PartNode=} opt_value
 * @param {number=} opt_index
 * @return {!proto.contentstore.PartNode}
 */
proto.contentstore.PartsManifest.prototype.addNodes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.contentstore.PartNode, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.contentstore.PartsManifest} returns this
 */
proto.contentstore.PartsManifest.prototype.clearNodesList = function() {
  return this.setNodesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.contentstore.PartBody.prototype.toObject = function(opt_includeInstance) {
  return proto.contentstore.PartBody.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.contentstore.PartBody} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.contentstore.PartBody.toObject = function(includeInstance, msg) {
  var f, obj = {
    index: jspb.Message.getFieldWithDefault(msg, 1, 0),
    mime: jspb.Message.getFieldWithDefault(msg, 2, ""),
    offset: jspb.Message.getFieldWithDefault(msg, 3, 0),
    length: jspb.Message.getFieldWithDefault(msg, 4, 0),
    sha256: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.contentstore.PartBody}
 */
proto.contentstore.PartBody.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.contentstore.PartBody;
  return proto.contentstore.PartBody.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.contentstore.PartBody} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.contentstore.PartBody}
 */
proto.contentstore.PartBody.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIndex(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMime(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFixed64());
      msg.setOffset(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFixed64());
      msg.setLength(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSha256(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.contentstore.PartBody.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.contentstore.PartBody.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.contentstore.PartBody} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.contentstore.PartBody.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIndex();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getMime();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOffset();
  if (f !== 0) {
    writer.writeFixed64(
      3,
      f
    );
  }
  f = message.getLength();
  if (f !== 0) {
    writer.writeFixed64(
      4,
      f
    );
  }
  f = message.getSha256();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional int32 index = 1;
 * @return {number}
 */
proto.contentstore.PartBody.prototype.getIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.contentstore.PartBody} returns this
 */
proto.contentstore.PartBody.prototype.setIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string mime = 2;
 * @return {string}
 */
proto.contentstore.PartBody.prototype.getMime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.contentstore.PartBody} returns this
 */
proto.contentstore.PartBody.prototype.setMime = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional fixed64 offset = 3;
 * @return {number}
 */
proto.contentstore.PartBody.prototype.getOffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.contentstore.PartBody} returns this
 */
proto.contentstore.PartBody.prototype.setOffset = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional fixed64 length = 4;
 * @return {number}
 */
proto.contentstore.PartBody.prototype.getLength = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.contentstore.PartBody} returns this
 */
proto.contentstore.PartBody.prototype.setLength = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string sha256 = 5;
 * @return {string}
 */
proto.contentstore.PartBody.prototype.getSha256 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.contentstore.PartBody} returns this
 */
proto.contentstore.PartBody.prototype.setSha256 = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.contentstore.PartNode.prototype.toObject = function(opt_includeInstance) {
  return proto.contentstore.PartNode.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.contentstore.PartNode} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.contentstore.PartNode.toObject = function(includeInstance, msg) {
  var f, obj = {
    ordinal: jspb.Message.getFieldWithDefault(msg, 1, 0),
    parentOrdinal: jspb.Message.getFieldWithDefault(msg, 2, 0),
    bodyIndex: jspb.Message.getFieldWithDefault(msg, 3, 0),
    kind: jspb.Message.getFieldWithDefault(msg, 4, 0),
    name: jspb.Message.getFieldWithDefault(msg, 5, ""),
    locator: (f = msg.getLocator()) && google_protobuf_struct_pb.Struct.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.contentstore.PartNode}
 */
proto.contentstore.PartNode.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.contentstore.PartNode;
  return proto.contentstore.PartNode.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.contentstore.PartNode} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.contentstore.PartNode}
 */
proto.contentstore.PartNode.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrdinal(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setParentOrdinal(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBodyIndex(value);
      break;
    case 4:
      var value = /** @type {!proto.contentstore.PartKind} */ (reader.readEnum());
      msg.setKind(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 6:
      var value = new google_protobuf_struct_pb.Struct;
      reader.readMessage(value,google_protobuf_struct_pb.Struct.deserializeBinaryFromReader);
      msg.setLocator(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.contentstore.PartNode.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.contentstore.PartNode.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.contentstore.PartNode} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.contentstore.PartNode.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrdinal();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getParentOrdinal();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getBodyIndex();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getKind();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getLocator();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_struct_pb.Struct.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 ordinal = 1;
 * @return {number}
 */
proto.contentstore.PartNode.prototype.getOrdinal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.contentstore.PartNode} returns this
 */
proto.contentstore.PartNode.prototype.setOrdinal = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 parent_ordinal = 2;
 * @return {number}
 */
proto.contentstore.PartNode.prototype.getParentOrdinal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.contentstore.PartNode} returns this
 */
proto.contentstore.PartNode.prototype.setParentOrdinal = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 body_index = 3;
 * @return {number}
 */
proto.contentstore.PartNode.prototype.getBodyIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.contentstore.PartNode} returns this
 */
proto.contentstore.PartNode.prototype.setBodyIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional PartKind kind = 4;
 * @return {!proto.contentstore.PartKind}
 */
proto.contentstore.PartNode.prototype.getKind = function() {
  return /** @type {!proto.contentstore.PartKind} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.contentstore.PartKind} value
 * @return {!proto.contentstore.PartNode} returns this
 */
proto.contentstore.PartNode.prototype.setKind = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string name = 5;
 * @return {string}
 */
proto.contentstore.PartNode.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.contentstore.PartNode} returns this
 */
proto.contentstore.PartNode.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional google.protobuf.Struct locator = 6;
 * @return {?proto.google.protobuf.Struct}
 */
proto.contentstore.PartNode.prototype.getLocator = function() {
  return /** @type{?proto.google.protobuf.Struct} */ (
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Struct, 6));
};


/**
 * @param {?proto.google.protobuf.Struct|undefined} value
 * @return {!proto.contentstore.PartNode} returns this
*/
proto.contentstore.PartNode.prototype.setLocator = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.contentstore.PartNode} returns this
 */
proto.contentstore.PartNode.prototype.clearLocator = function() {
  return this.setLocator(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.contentstore.PartNode.prototype.hasLocator = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * @enum {number}
 */
proto.contentstore.PartKind = {
  PART_KIND_UNSPECIFIED: 0,
  PART_KIND_DOCUMENT: 1,
  PART_KIND_PAGE: 2,
  PART_KIND_IMAGE: 3,
  PART_KIND_EMBEDDED: 4,
  PART_KIND_ATTACHMENT: 5
};

goog.object.extend(exports, proto.contentstore);
